import moment = require("moment");
import * as React from "react";
import DateUtils from "../../../../utils/DateUtils";
import "./presenter.scss";

interface IProps {
	value: string;
}

const TimePeriodPresenter: React.SFC<IProps> = (props: IProps) => {
	return (
		<div className={"presenter_time-period"}>
			<span>{parseIntoTimeFrame(props.value)}</span>
			<span>{moment(props.value).format(DateUtils.DMY_DATE_FORMAT)}</span>
		</div>
	);
};

/**
 * Parses given date into easy to read time frame
 * @param {moment.Moment} givenDate
 * @returns {string}
 */
export function parseIntoTimeFrame(givenDate: string) {
	const today = moment();
	const yesterday = moment().subtract(1, 'day');
	const isToday = moment(givenDate).isSame(today, 'day');
	const isYesterday = moment(givenDate).isSame(yesterday, 'day');
	const todayOrYesterdayWithDayTime = moment(givenDate).calendar();
	const defaultMomentTimeFrame = moment.duration(moment(givenDate).diff(moment())).humanize(true);
	if (isToday || isYesterday) {
		return todayOrYesterdayWithDayTime;
	}
	else {
		return defaultMomentTimeFrame;
	}
}

export default TimePeriodPresenter;
